// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OrderController_GetClients_ClientType,
  useOrderGetClientsQuery,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { ListData, ListDataQueryFunction } from 'api/types/data';
import { OrderClientsData } from 'api/types/data/order';
import { PrimaryClientType } from 'api/types/entity';
import { lodash } from 'helpers';

export const useOrderClients: ListDataQueryFunction<
  OrderClientsData,
  {
    search?: string;
  },
  '',
  { clientType: PrimaryClientType }
> = ({ pagination, filter, params }) => {
  const {
    loading,
    error: serverError,
    data,
  } = useOrderGetClientsQuery({
    variables: {
      limit: pagination.limit,
      clientType:
        QueryInput_OrderController_GetClients_ClientType[params!.clientType],
      page: pagination.page + 1,
      search: filter?.search?.toString() || undefined,
    },
  });

  const error = useError(serverError);

  const listData: ListData<OrderClientsData> | undefined = data?.clients
    ? {
        total: data?.clients.total,
        list: lodash.compact(data?.clients.list).map((record) => ({
          id: record.id,
          name: record.name,
          personalAccountNumber: record.personalAccountNumber,
        })),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
